import { render, staticRenderFns } from "./fkfs.vue?vue&type=template&id=0a052b2e&scoped=true&"
import script from "./fkfs.vue?vue&type=script&lang=js&"
export * from "./fkfs.vue?vue&type=script&lang=js&"
import style0 from "./fkfs.vue?vue&type=style&index=0&id=0a052b2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a052b2e",
  null
  
)

export default component.exports